import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
  TOGGLE_FORM_RESPONSE_OVERLAY,
} from './constants';

export const initAction = (id) => ({
  type: INIT,
  id,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error) => ({
  type: INIT_FAILED,
  error,
});

export const removeAction = (id, isSurvey) => ({
  type: REMOVE,
  id,
  isSurvey,
});
export const removeSuccessAction = () => ({
  type: REMOVE_SUCCESS,
});
export const removeFailedAction = (error, errorCode) => ({
  type: REMOVE_FAILED,
  error,
  errorCode,
});

export const toggleFormResponseOverlayAction = (responseId) => ({
  type: TOGGLE_FORM_RESPONSE_OVERLAY,
  responseId,
});
